///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../helpers/messages";

export const SystemError = ({ reloadPage }) => {
  return (
    <div
      data-testid="system-error"
      className="flex justify-center items-center text-center app-level-error"
    >
      <div className="content">
        <p className="uppercase univers-45-light tiny-title">
          {messages.oops.defaultMessage}
        </p>
        <p className="univers-65-bold title">
          {messages.systemError.defaultMessage}
        </p>
        <p className="text-dim-grey my-32 message">
          {messages.pageFailedToLoadMessage.defaultMessage}
        </p>
        <button
          data-testid="reload-button"
          className="primary-button univers-67-bold-cond px-48"
          onClick={reloadPage}
        >
          {messages.reload.defaultMessage}
        </button>
      </div>
    </div>
  );
};

export default SystemError;
